module.exports = __webpack_public_path__ + "static/media/asset_icon_dark.0d98b890.png";